import * as React from "react";
import { connect } from "react-redux";
import { IdLeagueGifts } from "../../constants/IdLeagueGifts";
import { selectGift, selectIsGiftAlreadyPurchased, } from "../../selectors/selectTournamentRewards";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionSetCurrentRewardInfo } from "./actionTournament";
import { ButtonGift } from "./ButtonGift";
import { LeaguePrizesAlreadyPurchased } from "./LeaguePrizesAlreadyPurchased";
import { LeaguePrizesAvailableSoon } from "./LeaguePrizesAvailableSoon";
export var _LeaguePrizesGift = function (_a) {
    var onGiftClick = _a.onGiftClick, leagueId = _a.leagueId, IdLeagueGift = _a.IdLeagueGift, giftAlreadyPurchased = _a.giftAlreadyPurchased, leagueType = _a.leagueType;
    var gift = selectGift(leagueId, IdLeagueGift, leagueType);
    if (leagueId === undefined) {
        return React.createElement(React.Fragment, null);
    }
    if (!gift) {
        return React.createElement(LeaguePrizesAvailableSoon, null);
    }
    if (giftAlreadyPurchased) {
        return React.createElement(LeaguePrizesAlreadyPurchased, null);
    }
    return (React.createElement(ButtonGift, { giftType: IdLeagueGift, onClick: function () { return onGiftClick(gift, leagueId, IdLeagueGift, leagueType); } }));
};
var mapState = function (state, props) {
    var giftAlreadyPurchased = selectIsGiftAlreadyPurchased(state, props.leagueId, props.IdLeagueGift, props.leagueType);
    return {
        giftAlreadyPurchased: giftAlreadyPurchased,
    };
};
var mapDispatch = function (dispatch) { return ({
    onGiftClick: function (currentPackage, giftLevel, rewardType, leagueType) {
        var modalId = rewardType === IdLeagueGifts.LeaguePremiumOffer
            ? IdModal.LeagueRewardSpecialOffer
            : IdModal.LeagueReward;
        dispatch(actionSetCurrentRewardInfo(currentPackage, giftLevel, rewardType, leagueType));
        dispatch(actionModalOpen(modalId));
    },
}); };
export var LeaguePrizesGift = connect(mapState, mapDispatch)(_LeaguePrizesGift);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/LeaguePrizesGift.tsx
// module id = 2789
// module chunks = 3